import React, { useEffect, useState } from 'react'
import { css, style } from 'glamor';
import { Link } from 'react-router-dom';
import { parseISO, format } from 'date-fns';
import CardThumbnail from '../../assets/images/Danske_bank_default.jpg';
import * as translate from '../../assets/translations/translations';
import InfiniteScroll from 'react-infinite-scroll-component';
import * as styles from './articlelistpagenew.style';
import spinner from '../../assets/icons/spinner.svg';
import rightArrow from '../../assets/icons/arrow-link-next_darkblue.svg';
import upArrow from '../../assets/icons/arrowUp.png';
import noImage from '../../assets/icons/no_results.svg';

const ArticleMainList = (props) => {
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [buttonPosition, setButtonPosition] = useState({ left: 260 }); // Default position

    const handleScroll = () => {
        setShowScrollToTop(window.scrollY > 1500);
    };

    const adjustButtonPosition = () => {
        const sidebar = document.querySelector('.sidebarFilter'); // Replace with the actual sidebar class or ID
        if (sidebar) {
            const sidebarRect = sidebar.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate dynamic bottom and left positions
            const leftOffset = sidebarRect.left + 20; // Add 20px padding from the sidebar

            setButtonPosition({ left: leftOffset });
        } else {
            // Fallback for when the sidebar is not present
            setButtonPosition({ left: 20 });
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', adjustButtonPosition);
        adjustButtonPosition(); // Initial adjustment

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', adjustButtonPosition);
        };
    }, []);

    return (
        <div>
            {
                props?.articlesData?.count == 0 ?
                    <div style={{ textAlign: 'center', marginTop: '70px' }}>
                        <div style={{ marginBottom: '40px' }}>
                            <img src={noImage} />
                        </div>
                        <div style={{ marginBottom: '40px' }}>
                            <p style={{ fontWeight: 600, marginBottom: '20px' }}>No results found</p>
                            <p style={{ fontWeight: 400, marginBottom: '20px' }}>Please adjust your filters.</p>
                        </div>
                        <div>
                            <button className='btn' style={{ cursor: 'pointer', width: '232px', height: '40px', color: '#007BC7', fontWeight: 600, borderRadius: '40px', backgroundColor: '#F4F6F9' }} onClick={() => props?.handleClearAllFilters()}>Clear Filters</button>
                        </div>
                    </div>
                    :
                    <InfiniteScroll /*{...css(styles.infiniteScroll)}*/
                        dataLength={props?.articlesData?.articles?.length ? props?.articlesData?.articles?.length : 0}
                        next={() => {
                            (props?.articlesData?.count >= props?.OffsetPage) && props?.handleSearch()
                        }}
                        hasMore={props?.hasMoreFinite}
                        loader={<img src={spinner} {...css(styles.spinner)} alt={translate.strings.TR262} aria-label={translate.strings.TR262} />}
                        style={{ marginTop: '-5px' }}
                    >
                        {
                            props?.articlesData?.articles?.length > 0 && props?.articlesData?.articles?.map((article, idx) => {
                                return (
                                    <Link to={{ pathname: props?.isCommissioned == true ? `/article/${article.articleid}/${article.language}/commr` : `/article/${article.articleid}/${article.language}` }} key={idx}>
                                        <div className="container-fluid"  {...css(styles.imageTextContainer)}>
                                            <div className="row">
                                                <div {...css(styles.imageContainer)} className="col-md-3 col-lg-3 col-sm-5 col-12">
                                                    {article.thumbnailMobile == undefined || article.thumbnailMobile == null || article.thumbnailMobile == "" ?
                                                        <img alt={article.title} {...css(styles.thumbnail)} src={CardThumbnail} /> :
                                                        <img {...css(styles.thumbnail)} alt={article.title} src={article.thumbnailMobile} />}

                                                </div>
                                                <div  {...css(styles.textContent)} className="col-md-7 col-lg-7 col-sm-7 col-12" role="region" aria-label="Articles">
                                                    <p {...css(styles.date)}>{format(parseISO(article.published_date), 'dd.MM.yyyy')}</p>
                                                    {/* <h3 {...css(styles.H3)}>{article.title}</h3> */}
                                                    <h1 {...css(styles.H3)}>{article.title}</h1>
                                                    <p {...css(styles.textParagraph)} dangerouslySetInnerHTML={{ __html: article.summary }} ></p>
                                                </div>
                                                <div className="col-md-2 col-lg-2 col-sm-2 col-12">
                                                    <img {...css(styles.rightArrow)} alt={article.title} src={rightArrow} />
                                                    <span {...css(styles.readMore)}>Read More</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })
                        }
                    </InfiniteScroll>
            }

            {
                (props?.articlesData?.articles?.length > 0 && showScrollToTop) &&
                <button onClick={scrollToTop} className='back_to_top' style={{
                    position: 'fixed',
                    bottom: `20px`, // Dynamically calculated
                    left: `${buttonPosition.left}px`, // Dynamically calculated
                    padding: '10px 20px',
                    backgroundColor: '#007BC7',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '-10px',
                }}>
                    <img src={upArrow} alt="Scroll to top" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                    Back to top
                </button>
            }

        </div>
    )
}

export default ArticleMainList